<script setup lang="ts">
import SkeletonBlock from './SkeletonBlock.vue'

withDefaults(defineProps<{ groups?: number; itemsPerGroup?: number }>(), {
  groups: 4,
  itemsPerGroup: 3,
})
</script>

<template>
  <div class="sk-sidebar-menu" aria-busy="true" aria-label="菜单加载中">
    <div v-for="g in groups" :key="g" class="sk-sidebar-menu__group">
      <div class="sk-sidebar-menu__group-title">
        <SkeletonBlock variant="circle" width="32px" height="32px" inline />
        <SkeletonBlock variant="text" width="72px" inline />
      </div>
      <div class="sk-sidebar-menu__items">
        <div v-for="i in itemsPerGroup" :key="`${g}-${i}`" class="sk-sidebar-menu__item">
          <SkeletonBlock variant="circle" width="28px" height="28px" inline />
          <SkeletonBlock variant="text" :width="`${48 + (i % 3) * 12}%`" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sk-sidebar-menu {
  padding: 8px 10px 16px;
}

.sk-sidebar-menu__group {
  margin-bottom: 12px;
}

.sk-sidebar-menu__group-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  margin-bottom: 4px;
}

.sk-sidebar-menu__items {
  margin: 0 8px;
  padding: 4px 0 8px;
  border-radius: 10px;
  background: var(--nav-sidebar-sub-bg);
}

.sk-sidebar-menu__item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 12px;
  margin: 2px 6px;
}
</style>
